let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ioTV7")).then(() => parcelRequire('9wYcO'));